import { Component, Input, OnInit, Inject, EventEmitter, Output } from '@angular/core';
import { IErrorHandler } from '../../../shared/dataModels/contracts/IErrorHandler';
import { Configuration } from '../../../shared/configurations/shared.config';
import { FileUploader } from '../../../shared/components/fileUpload/classes/file-uploader.class';
import { LocalizePipe } from '../../../shared/pipes/Localize.pipe';

@Component({
    moduleId: module.id,
    selector: 'tab-item',
    templateUrl: 'tab-item.component.html',
})
export class TabItemComponent {

    private _errorHandler: IErrorHandler;

    @Input() id: string;
    @Input() header: string;
    @Input() active: boolean;

    @Output() onSelected: EventEmitter<any> = new EventEmitter<any>();

    constructor( @Inject("IErrorHandler") handler: IErrorHandler, private _localizer: LocalizePipe) {

        this._errorHandler = handler;
    }


}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/tabs/tab-item.component.ts